var map = {
	"./chatFolder.png": "7d60",
	"./cleaver/dos.png": "2957",
	"./cleaver/p1.png": "6cdf",
	"./cleaver/p2.png": "0b4b",
	"./cleaver/p3.png": "3d44",
	"./cleaver/p4.png": "c146",
	"./cleaver/quatro.png": "8077",
	"./cleaver/tres.png": "ae33",
	"./cleaver/uno.png": "09c7",
	"./clippy.png": "7e40",
	"./clippySmall.png": "474e",
	"./coffeeCan/feedback.png": "c8b0",
	"./coffeeCan/handle.jpg": "b74c",
	"./cursor.png": "6ddd",
	"./cursorPoint.png": "a70b",
	"./document.png": "737e",
	"./favoritesFolder.png": "307b",
	"./folder.png": "f27d",
	"./gemFolder.png": "f71d",
	"./globe.png": "7be2",
	"./linkedIn.png": "4d38",
	"./linkedInBW.png": "e073",
	"./logo.png": "cf05",
	"./magnifyingGlass.png": "5413",
	"./mainFolder.png": "52bdf",
	"./smartbelt/belt.png": "585b",
	"./smartbelt/exploaded.png": "15b3",
	"./smartbelt/pcb.png": "6e12",
	"./smartbelt/pcbBack.png": "cc44",
	"./svg/background/Coaxer-01.svg": "3b3f",
	"./svg/background/Coaxer.jpg": "db16",
	"./svg/background/ringmerkingFigma.svg": "f613",
	"./svg/background/ringmerkingNO.svg": "e0f2",
	"./svg/headerButton/close.svg": "d1b3",
	"./svg/headerButton/maximize.svg": "6b97",
	"./svg/headerButton/minimize.svg": "0a33",
	"./svg/headerButton/restore.svg": "babb",
	"./svg/pics/illu.svg": "f452",
	"./svg/pics/scenario.svg": "c2c9",
	"./svg/pics/topicoDevice.svg": "10ae",
	"./windowsicon.png": "2a64",
	"./windowsicon.png.png": "1801"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";